<template>
    <div class="flex_content">

        <div id="context_bar">
            <TopbarGoPositionsList />
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1" v-if="currentPosition">{{ currentPosition.name }}</h1>
                <h2 class="associated_ref_name" v-if="currentRef"><span>{{ currentRef.name }}</span></h2>
            </template>
        </titlePage>
        <nav v-if="candidatesTotalPages > 1" class="pagination table-pagination is-centered is-medium position_evals_pagination">
            <paginate
                :page-count="candidatesTotalPages"
                :click-handler="OnPageChange"
                :prev-text="'<'"
                :next-text="'>'"
                :page-link-class="'pagination-link'"
                :active-class="'is-current'"
                :prev-link-class="'pagination-link'"
                :next-link-class="'pagination-link'"
                :disabled-class="'is-disabled'"
                :container-class="'pagination-list'">
            </paginate>
        </nav>


        <div v-if="currentPosition">
            <div class="eval_tabs">
                <BtnTab btn-id="PostitionEvalsGeneralTab" :active-tab="currentTab == 'PostitionEvalsGeneralTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.positions.evals_detail.generalTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsActualTab" :active-tab="currentTab == 'PostitionEvalsActualTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.positions.evals_detail.actualTab') }}
                </BtnTab>
                <BtnTab btn-id="PostitionEvalsUltimTab" :active-tab="currentTab == 'PostitionEvalsUltimTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.positions.evals_detail.ultimTab') }}
                </BtnTab>
            </div>

            <div class="tabs_content" >

                <transition name="survey-fade">
                    <component :is="currentTab" :dataLoaded="dataLoaded" :currentPosition="currentPosition" :evaluations="evaluations" :currentRef="currentRef" @reorderEval="reorderEval"  ></component>
                </transition>

            </div>

            <nav v-if="candidatesTotalPages > 1" class="pagination table-pagination is-centered is-medium position_evals_pagination_bottom">
                <paginate
                    :page-count="candidatesTotalPages"
                    :click-handler="OnPageChange"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :page-link-class="'pagination-link'"
                    :active-class="'is-current'"
                    :prev-link-class="'pagination-link'"
                    :next-link-class="'pagination-link'"
                    :disabled-class="'is-disabled'"
                    :container-class="'pagination-list'">
                </paginate>
            </nav>
        </div>
    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"

import PostitionEvalsActualTab from "../components/evaluations/actualTab"
import PostitionEvalsGeneralTab from "../components/evaluations/generalTab"
import PostitionEvalsUltimTab from "../components/evaluations/ultimTab"



export default {
    name: 'PositionEvaluations',
    components: {
        TitlePage,
        TopbarGoPositionsList,
        PostitionEvalsActualTab,
        PostitionEvalsUltimTab,
        PostitionEvalsGeneralTab,
    },
    created(){
        this.$store.dispatch('PositionStore/getPosition', this.$route.params.id).then(() => {
            this.$store.dispatch('PositionStore/getPositionEvals', {position_id: this.$store.state.PositionStore.currentPosition.id, only_completed: 0, current_page: 1, item_per_page: 50 })
        })
    },
    mounted(){

    },
    data(){
        return {
            currentTab: 'PostitionEvalsGeneralTab',
            sort_type: 'ASC',
            sorting_column: null,
            dataLoaded: true
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        evaluations(){
            return this.$store.state.PositionStore.PositionEvals
        },
        currentRef(){
            return this.currentPosition.sight_ref
        },
        candidatesCurrentPage(){
            return this.$store.state.PositionStore.candidatesCurrentPage
        },
        candidatesTotalPages(){
            return this.$store.state.PositionStore.candidatesTotalPages
        },
        candidatesItemPerPage(){
            return this.$store.state.PositionStore.candidatesItemPerPage
        },
        isRespect(){
            return JSON.parse(localStorage.getItem('account')).is_respect
        }
    },
    methods: {
        changeTab(tabName){
            this.dataLoaded = false
            this.currentTab = tabName
            var onlyCompleted = 1
            if (tabName == 'PostitionEvalsGeneralTab'){ onlyCompleted =  0 }
            const queryData = {
                position_id: this.$store.state.PositionStore.currentPosition.id,
                only_completed: onlyCompleted,
                current_page: this.candidatesCurrentPage,
                item_per_page: this.candidatesItemPerPage }
            this.$store.dispatch('PositionStore/getPositionEvals', queryData).then(err => {
                setTimeout(() => { this.dataLoaded = true }, 150)
            })
        },
        toggleSortingType(){
            this.sort_type == 'ASC' ? this.sort_type = 'DESC' : this.sort_type = 'ASC'
        },
        reorderEval(column){
            var onlyCompleted = "1"
            if (this.sorting_column == column){
                this.toggleSortingType()
            }else{
                this.sorting_column = column
                this.sort_type == 'ASC'
            }
            if(this.currentTab == 'PostitionEvalsGeneralTab'){onlyCompleted = "0"}
            const queryData = {
                position_id: this.currentPosition.id,
                sort_column: column,
                sort_type: this.sort_type,
                only_completed: onlyCompleted,
                current_page: this.candidatesCurrentPage,
                item_per_page: this.candidatesItemPerPage }
            this.$store.dispatch('PositionStore/getPositionEvals', queryData)
        },
        OnPageChange(targetpage){
            this.dataLoaded = false
            var onlyCompleted = 1
            if (this.currentTab == 'PostitionEvalsGeneralTab'){ onlyCompleted =  0 }
            const queryData = {
                position_id: this.currentPosition.id,
                only_completed: onlyCompleted,
                current_page: targetpage,
                item_per_page: this.candidatesItemPerPage }
            this.$store.dispatch('PositionStore/getPositionEvals', queryData).then(err => {
                setTimeout(() => { this.dataLoaded = true }, 150)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#index_eval_content{
    background: $white;
}
.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
}
.position_evals_pagination{
    background: white;
}
.tabs_content{
    padding-bottom: 20px;
}
</style>
